import patentBred from "../assets/images/patent-bred.jpeg";
import darkMocha from "../assets/images/dark-mocha.jpeg";
import chicago from "../assets/images/chicago.jpeg";
import fearless from "../assets/images/fearless.jpeg";
import shadow from "../assets/images/shadow.jpeg";
import universityBlue from "../assets/images/univeristy-blue.jpeg";
import crimsonTint from "../assets/images/crimson-tint.jpeg";
import royal from "../assets/images/royal.jpeg";
import bredToe from "../assets/images/bred-toe.jpeg";
import shatteredBackboard from "../assets/images/shattered-backboard.jpeg";

const mockData = [
  {
    id: 1,
    type: "Air Jordan 1",
    name: "Patent Bred",
    image: patentBred,
    price: "free.99",
    color: "red | black | white",
    detail: `A colorway synonymous with His Airness for over 35 years, the Air Jordan 1 Black and Red returns this season to shine like never before. Made famous by its "banned" mythology and MJ's majestical jumps during the 1985 dunk contest, this edition is covered in patent leather, adding a touch of luxury to one of MJ's most legendary looks.`,
  },
  {
    id: 2,
    type: "Air Jordan 1",
    name: "Dark Mocha",
    image: darkMocha,
    price: "free.99",
    color: "white | mocha | black",
    detail: `Detail goes here....`,
  },
  {
    id: 3,
    type: "Off White X Air Jordan 1",
    name: "Chicago",
    image: chicago,
    price: "free.99",
    color: "red | black | cream",
    detail: `Detail goes here....`,
  },
  {
    id: 4,
    type: "Air Jordan 1",
    name: "Fearless",
    image: fearless,
    price: "free.99",
    color: "nc blue | black | white | red",
    detail: `Detail goes here....`,
  },
  {
    id: 5,
    type: "Air Jordan 1",
    name: "Shadow",
    image: shadow,
    price: "free.99",
    color: "black | gray | white",
    detail: `Detail goes here....`,
  },
  {
    id: 6,
    type: "Air Jordan 1",
    name: "University Blue",
    image: universityBlue,
    price: "free.99",
    color: "nc blue | black | white",
    detail: `Detail goes here....`,
  },
  {
    id: 7,
    type: "Air Jordan 1",
    name: "Crimson Tint",
    image: crimsonTint,
    price: "free.99",
    color: "crimson | black | white",
    detail: `Detail goes here....`,
  },
  {
    id: 8,
    type: "Air Jordan 1",
    name: "Royal",
    image: royal,
    price: "free.99",
    color: "royal blue | black | white",
    detail: `Detail goes here....`,
  },
  {
    id: 9,
    type: "Air Jordan 1",
    name: "Bred Toe",
    image: bredToe,
    price: "free.99",
    color: "red | black | white",
    detail: `Detail goes here....`,
  },
  {
    id: 10,
    type: "Air Jordan 1",
    name: "Shattered Backboard",
    image: shatteredBackboard,
    price: "free.99",
    color: "orange | black | white",
    detail: `Detail goes here....`,
  },
];

export { mockData };
